import type { ReactElement } from "react";

interface ArticlePhotoProps {
  alt: string;
  className?: string;
  label: string;
  orientation?: "landscape" | "portrait";
  priority?: boolean;
  src?: string;
}

export const ArticlePhoto = ({
  alt,
  className = "",
  label,
  orientation = "landscape",
  priority = false,
  src,
}: ArticlePhotoProps): ReactElement => (
  <figure className={`article-photo article-photo--${orientation} ${className}`.trim()}>
    {src ? (
      <img alt={alt} decoding="async" loading={priority ? "eager" : "lazy"} src={src} />
    ) : (
      <div aria-label={`${label} placeholder`} className="article-photo__placeholder" role="img">
        <span>{label}</span>
      </div>
    )}
  </figure>
);
